
"use client";
import { createContext, useState, useContext, useEffect, useMemo } from "react";
import { get_prefix_urls_banners_proxy } from "@core/services/seo";
import { usePathname } from "next/navigation";
import { strip_locale_prefix } from "@core/helpers/locale-path";

const BannerContext = createContext();

export const useBannerContext = () => useContext(BannerContext);

export const BannerProvider = ({ children, current_locate }) => {
  const [banner_data, set_banner_data] = useState(null);
  const [banner_loading, set_banner_loading] = useState({});

  const pathname = usePathname();

  useEffect(() => {
    const fetch_banner_data = async () => {
      try {
        if (pathname) {
          // only a leading locale segment: `replace("/fa", "")` also cut "/fa" out of "/fashion-news/" (found:false,
          // the banner disappeared after load and shifted the page)
          let _pathname = strip_locale_prefix(pathname, current_locate);

          set_banner_loading(true);

          let result = await get_prefix_urls_banners_proxy({ url: _pathname });

          if (result?.status && result?.data?.found) {
            set_banner_data(result?.data?.banners);
          }

          set_banner_loading(false);
        }
      } catch (error) {
        console.error("Error fetching banner data:", error);
      }
    };

    fetch_banner_data();
  }, [pathname]);

  const value = useMemo(
    () => ({
      banner_data,
      banner_loading,
    }),
    [banner_data, banner_loading]
  );

  return (
    <BannerContext.Provider value={value}>{children}</BannerContext.Provider>
  );
};
